export const _DEFAULT_CONFIG = {
  watch: true,
  refetchOnWindowFocus: true,
  approveMax: true,
  showAllNotifications: false,
};
